// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { Component, Prop, Host, h } from '@stencil/core';
import { BannerConfig, BannerStyles, Proposal } from './addi-product-banner.d';
import { bannerBuilder as bannerBuildCO } from './../content-builder/content-builder';
import { bannerBuilder as bannerBuilderBR } from './../content-builder-br/content-builder';
import { Template } from '../content-builder/templates/types';
import { setBannerCustomStyles } from './addi-product-banner.custom-styles';

@Component({
  tag: 'addi-product-banner',
  styleUrl: 'addi-product-banner.scss',
  shadow: true,
})
export class AddiProductBanner {
  @Prop() preRender: boolean;
  @Prop() widgetId: string;
  @Prop() version: string;
  @Prop() preapproval: boolean;
  @Prop() customBannerStyle: BannerStyles;
  @Prop() proposal: Proposal;
  @Prop() allySlug: string;
  @Prop() country: string;
  @Prop() preApprovalVersion: string;

  bannerBuilder = null;

  componentWillLoad() {
    this.bannerBuilder =
      this.country === 'co' ? bannerBuildCO : bannerBuilderBR;
  }

  /**
   * Build the widget with the corresponding template depending on the widget version
   *
   * The default template is ADDI_TEMPLATE_01 (BNPL)
   */
  renderBanner(): HTMLElement {
    if (this.preRender) {
      return this.bannerBuilder(null, {
        customBannerStyle: this.customBannerStyle,
      } as BannerConfig);
    }

    const bannerIdSegments = this.widgetId.split('_');
    const BNPLWidgetData: BannerConfig = {
      id: bannerIdSegments[1],
      preapproval: this.preapproval,
      customBannerStyle: this.customBannerStyle,
      proposal: this.proposal,
      allySlug: this.allySlug,
      preApprovalVersion: this.preApprovalVersion,
    };

    return this.bannerBuilder(this.version as Template, BNPLWidgetData);
  }

  renderBannerStyles(): HTMLElement {
    if (!this.customBannerStyle) return;

    return <style>{setBannerCustomStyles(this.customBannerStyle)}</style>;
  }

  render() {
    return (
      <Host>
        {this.renderBannerStyles()}
        {this.renderBanner()}
      </Host>
    );
  }
}
